import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import moment from 'moment';
import { Subscription, interval } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { BonusApi } from 'src/app/shared/apis/bonus.api';
import { ImgCarouselOptions } from 'src/app/shared/components/img-carousel/img-carousel-options.interface';
import { ImgCarouselComponent } from 'src/app/shared/components/img-carousel/img-carousel.component';
import { LeaderBoardPopupComponent } from 'src/app/shared/components/leader-board-popup/leader-board-popup.component';
import { PaginatorState } from 'src/app/shared/components/paginator/paginator.module';
import { GameListItem, GameProviderParams } from 'src/app/shared/interfaces/game.interface';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { PopupService } from 'src/app/shared/service/popup.service';
import { DailyRacesService } from '../../daily-races/daily-races.service';
import { MiniGameService } from '../../minigame/minigame.service';

@UntilDestroy()
@Component({
  selector: 'app-daily-contest',
  templateUrl: './daily-contest.component.html',
  styleUrls: ['./daily-contest.component.scss'],
})
export class DailyContestComponent implements OnInit {
  constructor(
    private appService: AppService,
    private router: Router,
    private localeService: LocaleService,
    private bounsApi: BonusApi,
    private popupService: PopupService,
    private ngZone: NgZone,
    private miniGameService: MiniGameService,
    public dailyRacesService: DailyRacesService,
  ) {}

  /** 显示当前比赛 和 剩余时间 */
  topList: any[] = [];

  /** 列表第一排标题 */
  listFirstRow: any = [
    {
      icon: null,
      text: this.localeService.getValue('rank_a'),
    },
    {
      icon: null,
      text: this.localeService.getValue('gamer'),
    },
    {
      icon: 'icon-warning',
      text: this.localeService.getValue('race_total_bet'),
      toolTips: this.localeService.getValue('race_tips'),
    },
    {
      icon: null,
      text: this.localeService.getValue('race_reward'),
    },
  ];
  titleData: any = [
    // 0-有效流水
    {
      type: 0,
      titleArr: [
        {
          icon: null,
          text: this.localeService.getValue('rank_a'),
        },
        {
          icon: null,
          text: `${this.localeService.getValue('gamer')}, ${this.localeService.getValue('race_total_bet')}`,
        },
        {
          icon: null,
          text: this.localeService.getValue('race_reward'),
        },
      ],
    },
    // 10-大赢家(总输赢)
    {
      type: 10,
      titleArr: [
        {
          icon: null,
          text: this.localeService.getValue('rank_a'),
        },
        {
          icon: null,
          text: `${this.localeService.getValue('gamer')}, ${this.localeService.getValue('total_w_l')}`,
        },
        {
          icon: null,
          text: this.localeService.getValue('race_reward'),
        },
      ],
    },
    // 11-大赢家(单笔最大盈利)
    {
      type: 11,
      titleArr: [
        {
          icon: null,
          text: this.localeService.getValue('rank_a'),
        },
        {
          icon: null,
          text: `${this.localeService.getValue('gamer')}, ${this.localeService.getValue('maximum_profit_amount')}`,
        },
        {
          icon: null,
          text: this.localeService.getValue('race_reward'),
        },
      ],
    },
    // 2-运气最好
    {
      type: 2,
      titleArr: [
        {
          icon: null,
          text: this.localeService.getValue('rank_a'),
        },
        {
          icon: null,
          text: `${this.localeService.getValue('gamer')}, ${this.localeService.getValue('good_luck')}`,
        },
        {
          icon: null,
          text: this.localeService.getValue('race_reward'),
        },
      ],
    },
  ];

  /** 剩余时间 */
  remainingTime = {
    day: 0,
    hour: 0,
    min: 0,
    sec: 0,
  };

  /** 计时器订阅 */
  timerSubscription!: Subscription;

  /** 选择活动的当前下表 */
  selectedActivitIndex: number = 0;

  selectTitleData = this.titleData[this.selectedActivitIndex].titleArr;

  /** 分页器 */
  paginator: PaginatorState = {
    page: 1,
    pageSize: 21,
    total: 0,
  };

  /** 排名数据 */
  leaderBoardList: any[] = [];

  /** loading */
  rankLoading: boolean = false;

  gameLoading: boolean = false;

  selectProviders: string[] = [];

  games: any[] = [];

  showRule: boolean = false;

  selectedType!: number;
  /** 返回執行的type種類 */
  // 0-有效流水
  // 10-大赢家(总输赢)
  // 11-大赢家(单笔最大盈利)
  // 2-运气最好
  // 3-积分规则
  executeTypeList = [
    {
      type: 0,
      title: this.localeService.getValue('effective_flow'),
    },
    {
      type: 10,
      title: this.localeService.getValue('big_win_total'),
    },
    {
      type: 11,
      title: this.localeService.getValue('big_win_single'),
    },
    {
      type: 2,
      title: this.localeService.getValue('best_luck'),
    },
    {
      type: 3,
      title: this.localeService.getValue('points_rules'),
    },
  ];

  /** 首次进入loading */
  topListLoading: boolean = false;

  /** swiper的 是否准备好了 */
  swiperReady: boolean = false;

  /** gameItemReady 小游戏入口是否准备完毕 */
  gameItemReady: boolean = false;

  updatedFavoriteIds = this.miniGameService.allFavoriteIds$.pipe(untilDestroyed(this)).subscribe(ids => {
    if (!this.games) return;
    this.games.forEach((item: GameListItem) => {
      item.isFavorite = ids.includes(item.id);
    });
  });

  ngOnInit(): void {
    this.getTitleList();
  }

  @ViewChild('swiperLeaderBoard') swiperLeaderBoard?: ImgCarouselComponent;
  swiperOptions: ImgCarouselOptions = {
    loop: true,
    allowTouchMove: true,
    pagination: false,
    /** 当前要显示的数量 */
    slidesPerView: 1,
    /** 一次滚动的数量 */
    slidesPerGroup: 1,
    /** Item间距，单位px */
    spaceBetween: 0,
  };

  /** 获取活动 导航列表 */
  getTitleList() {
    this.topListLoading = true;
    this.dailyRacesService.getDailyTitles().subscribe(list => {
      this.topListLoading = false;
      this.topList = list?.title || [];

      if (this.topList.length > 0) {
        this.topList.forEach(x => {
          x.type = this.executeTypeList.find(y => y.type == x.executeType)?.title;
        });
        this.selectedType = this.topList[this.selectedActivitIndex].executeType;
        this.selectTitleData = this.titleData.find((x: any) => x.type == this.selectedType).titleArr;
        this.getRank();
        this.onStartClock();
        this.getGameByProvider(true);
      }
    });
  }

  /** 开始倒数计时 */
  onStartClock() {
    this.timerSubscription?.unsubscribe();
    let remainingTime = this.topList[this.selectedActivitIndex].remainingTime;
    this.timerSubscription = interval(1000)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        remainingTime -= 1000;
        if (remainingTime <= 0) this.timerSubscription?.unsubscribe();
        this.remainingTime.day = moment.duration(remainingTime).days();
        this.remainingTime.hour = moment.duration(remainingTime).hours();
        this.remainingTime.min = moment.duration(remainingTime).minutes();
        this.remainingTime.sec = moment.duration(remainingTime).seconds();
      });
  }

  /** 获取所有排名 */
  getRank() {
    this.rankLoading = true;
    const params = {
      activitiesNo: this.topList[this.selectedActivitIndex]?.activitiesNo || '',
      pageIndex: 1,
      pageSize: 5,
    };
    this.bounsApi.getRank(params).subscribe(data => {
      this.rankLoading = false;
      if (data?.bonusInfo) {
        this.leaderBoardList = data.bonusInfo || [];
      } else {
        this.leaderBoardList = [];
      }
    });
  }

  // 获取小游戏的详情页面
  clickDetailItem(id: string, gameName: string) {
    this.router.navigateByUrl(`${this.appService.languageCode}/casino/games/${id}/${gameName}`);
  }
  /**
   * 開啟排行榜
   */
  openLeaderBoardPopup() {
    this.popupService.open(LeaderBoardPopupComponent, {
      speed: 'faster',
      data: {
        index: this.selectedActivitIndex,
      },
    });
  }

  // 正式筛选游戏数据的请求
  getGameByProvider(init: boolean) {
    if (init) {
      this.paginator.page = 1;
      this.paginator.total = 0;
      this.paginator.pageSize = 12;
    }
    this.selectProviders = this.topList[this.selectedActivitIndex].providerCatIds;
    if (
      this.topList[this.selectedActivitIndex].providerCatIds.length == 0 &&
      this.topList[this.selectedActivitIndex].gameLists.length !== 0
    ) {
      this.games = [];
      this.paginator.total = this.topList[this.selectedActivitIndex].gameLists.length;
      this.paginator.pageSize = this.topList[this.selectedActivitIndex].gameLists.length;
      this.games = this.topList[this.selectedActivitIndex].gameLists;
      return;
    }
    const param: GameProviderParams = {
      labelCode: [],
      providerCatIds: this.selectProviders,
      sort: 'AZ',
      pageIndex: this.paginator.page,
      pageSize: this.paginator.pageSize,
      sortType: 'ProviderSort',
    };
    this.gameLoading = true;
    this.miniGameService.getGameByProvider(param).subscribe(data => {
      this.gameLoading = false;
      if (data?.list?.length > 0) {
        this.paginator.total = data.total;
        if (init) {
          this.games = data.list;
        } else {
          this.games.push(...data.list);
        }
      } else {
        this.games = [];
      }
    });
  }

  slideChange(index: number) {
    this.ngZone.run(() => {
      this.remainingTime = {
        day: 0,
        hour: 0,
        min: 0,
        sec: 0,
      };
      this.selectedActivitIndex = index;
      this.getTitleList();
    });
  }
}
